import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    name: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,
    colorSupport: PropTypes.oneOf(["01", "02", "03", "04"]).isRequired
};

const AvailabilitySiteTypeItem = ({ name, colorSupport, icon }) => (
    <div className="rec-availability-item">
        <div className={`rec-availability-block-icon rec-color-support-${colorSupport}`}>
            {icon}
        </div>
        <div className="rec-availability-item-type">
            {name}
        </div>
    </div>
);

AvailabilitySiteTypeItem.propTypes = propTypes;

export default AvailabilitySiteTypeItem;
